<div class="flex flex-col gap-4">
  <div class="flex shrink-0 flex-wrap items-center justify-between gap-2">
    <h2 class="text-lg font-semibold text-surface-900 dark:text-surface-0 m-0">Suggestion chips</h2>
    <div class="flex flex-wrap items-center gap-2">
      <p-select
        [options]="agentFilterOptions"
        [ngModel]="agentFilter()"
        (ngModelChange)="onAgentFilterChange($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="Filter by agent"
        styleClass="min-w-[10rem]"
        ariaLabel="Filter suggestions by agent"
      />
      <p-button label="Refresh" icon="pi pi-refresh" [outlined]="true" [disabled]="loading()" (onClick)="reload()" />
      <p-button label="New suggestion" icon="pi pi-plus" (onClick)="openCreate()" />
    </div>
  </div>

  <div class="rounded-lg border border-surface-200 dark:border-surface-700">
    <p-table
      [value]="rows()"
      dataKey="key"
      [loading]="loading() && rows().length === 0"
      [showLoader]="true"
      [paginator]="true"
      [rows]="tableRowsPerPage"
      [alwaysShowPaginator]="false"
      sortMode="single"
      sortField="modifiedAt"
      [sortOrder]="-1"
      [stripedRows]="true"
      [showGridlines]="true"
      styleClass="border-0 text-sm shadow-none"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
    <ng-template pTemplate="header">
      <tr>
        <th scope="col">Agent</th>
        <th scope="col">CTA</th>
        <th scope="col">Macro</th>
        <th pSortableColumn="active" scope="col" class="whitespace-nowrap">
          <span class="inline-flex items-center gap-1">
            Active
            <p-sortIcon field="active" />
          </span>
        </th>
        <th pSortableColumn="modifiedAt" scope="col" class="whitespace-nowrap">
          <span class="inline-flex items-center gap-1">
            Modified
            <p-sortIcon field="modifiedAt" />
          </span>
        </th>
        <th scope="col" class="w-32 text-end">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="font-mono text-xs">{{ row.agentId ?? '—' }}</td>
        <td>{{ row.cta }}</td>
        <td class="text-surface-600 dark:text-surface-400 max-w-md">{{ macroPreview(row.macro) }}</td>
        <td>{{ row.active ? 'Yes' : 'No' }}</td>
        <td class="text-xs text-surface-600 dark:text-surface-400">{{ row.modifiedAt ?? '—' }}</td>
        <td class="text-end">
          <div class="flex flex-wrap justify-end gap-1">
            <p-button icon="pi pi-pencil" [text]="true" rounded (onClick)="openEdit(row)" [attr.aria-label]="'Edit ' + row.cta" />
            <p-button icon="pi pi-trash" [text]="true" rounded severity="danger" (onClick)="deleteRow(row)" [attr.aria-label]="'Delete ' + row.cta" />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="px-3 py-6 text-center text-surface-600 dark:text-surface-400">No rows returned.</td>
      </tr>
    </ng-template>
    </p-table>
  </div>

  <p-dialog
    [header]="isEditMode() ? 'Edit suggestion' : 'New suggestion'"
    [modal]="true"
    [style]="{ width: 'min(40rem, 95vw)' }"
    [visible]="dialogOpen()"
    (visibleChange)="dialogOpen.set($event)"
    [closable]="true"
  >
    <form class="flex flex-col gap-3" [formGroup]="form" (ngSubmit)="save()">
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium" for="csa-agent">Agent</label>
        <p-select
          inputId="csa-agent"
          formControlName="agentId"
          [options]="agentCreateOptions"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
          ariaLabel="Agent id for this suggestion"
        />
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium" for="csa-cta">CTA</label>
        <input pInputText id="csa-cta" class="w-full" formControlName="cta" autocomplete="off" />
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium" for="csa-macro">Macro</label>
        <textarea pTextarea id="csa-macro" class="w-full" rows="5" formControlName="macro"></textarea>
      </div>
      <div class="flex items-center gap-2">
        <p-checkbox inputId="csa-active" formControlName="active" [binary]="true" />
        <label class="text-sm" for="csa-active">Active</label>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium" for="csa-version">Version (optional)</label>
        <input pInputText id="csa-version" class="w-full" formControlName="version" autocomplete="off" />
      </div>
      @if (isEditMode()) {
        <div class="flex items-center gap-2">
          <p-checkbox inputId="csa-clear-version" formControlName="clearVersion" [binary]="true" />
          <label class="text-sm" for="csa-clear-version">Remove stored version (omit from request)</label>
        </div>
      }
      <div class="flex justify-end gap-2 pt-2">
        <p-button type="button" label="Cancel" [outlined]="true" (onClick)="closeDialog()" />
        <p-button type="submit" [label]="isEditMode() ? 'Save' : 'Create'" [loading]="saving()" [disabled]="saving()" />
      </div>
    </form>
  </p-dialog>
</div>
